"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.start.recording': 'Rozpocznij Nagrywanie',
    'conversation.start.failed': 'Nie udało się rozpocząć konwersacji',
};
